module.exports = __webpack_public_path__ + "img/shopee.1f3868c0.png";